import type { PropsWithChildren } from 'react';
import { useContext } from 'react';

import { SlideToggle } from '@procurify/ui'

import { StatusCardLegacyCollapsibleStyled } from './styles/StatusCardLegacyCollapsibleStyled'
import { StatusCardLegacyContext } from '../../StatusCardLegacyContext'
import { StatusCardLegacyCollapsibleToggle } from '../StatusCardLegacyCollapsibleToggle'

export interface IStatusCardLegacyCollapsibleProps {}

export const StatusCardLegacyCollapsible = ({
  children,
}: PropsWithChildren<IStatusCardLegacyCollapsibleProps>) => {
  const { showCollapsible } = useContext(StatusCardLegacyContext)

  return (
    <StatusCardLegacyCollapsibleStyled>
      <SlideToggle show={showCollapsible}>{children}</SlideToggle>
    </StatusCardLegacyCollapsibleStyled>
  )
}

StatusCardLegacyCollapsible.Toggle = StatusCardLegacyCollapsibleToggle

StatusCardLegacyCollapsible.displayName = 'StatusCardLegacyCollapsible'
